import { Header, Icon, Segment } from "semantic-ui-react";
import React from "react";

export const ErrorSegment = (props) => (
  <Segment placeholder>
    <Header icon>
      <Icon name="warning sign" color="yellow" />
      Houve um erro ao processar sua solicitação! Por favor, tente novamente!
    </Header>
    <Segment.Inline>
      <p>Detalhes do erro: "{props.message}"</p>
    </Segment.Inline>
  </Segment>
);
